<template>
  <GDrawer
    :model-value="modelValue"
    title="Activa tus cuentas de stablecoins"
    size="400px"
    destroy-on-close
    @close="closeDrawer"
  >
    <CreateWalletStablecoinConfirmation />

    <template #footer>
      <div class="flex flex-col gap-3">
        <p class="text-3 font-medium text-terciary-txt text-left">
          Al continuar estás aceptando los
          <GLink :href="stablecoinTermsUrl" target="_blank">Términos y Condiciones del servicio.</GLink>
        </p>
        <GButton full variant="primary" @click="confirmCreateWallet">Abrir nueva cuenta</GButton>
      </div>
    </template>
  </GDrawer>
</template>

<script lang="ts" setup>
import { GDrawer } from '@flash-global66/g-drawer';
import { GButton } from '@flash-global66/g-button';
import { GLink } from '@flash-global66/g-link';

import type {
  StablecoinConfirmationDrawerProps,
  StablecoinConfirmationDrawerEmit,
} from '../../types/createWalletStablecoinDrawer.type';

import CreateWalletStablecoinConfirmation from '../../views/CreateWalletStablecoinConfirmation/index.vue';
import { useCreateWalletStablecoinDrawer } from './useCreateWalletStablecoinDrawer';

const props = defineProps<StablecoinConfirmationDrawerProps>();

const emit = defineEmits<StablecoinConfirmationDrawerEmit>();

const { stablecoinTermsUrl, confirmCreateWallet, closeDrawer } = useCreateWalletStablecoinDrawer(
  props,
  emit
);
</script>
